import { render, staticRenderFns } from "./DetailListItem.vue?vue&type=template&id=3a90b3ce&scoped=true"
import script from "./DetailListItem.vue?vue&type=script&lang=js"
export * from "./DetailListItem.vue?vue&type=script&lang=js"
import style0 from "./DetailListItem.vue?vue&type=style&index=0&id=3a90b3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90b3ce",
  null
  
)

export default component.exports